import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/PlusCircle.es.js";
const o = e.forwardRef((r, c) => /* @__PURE__ */ e.createElement(s, { ref: c, ...r, weights: t }));
o.displayName = "PlusCircleIcon";
const l = o;
export {
  l as PlusCircle,
  o as PlusCircleIcon
};
